import Model from '@/models/Model'
import ParagraphModel from '@/models/ParagraphModel'
import ParagraphKeyFigureModel from '@/models/ParagraphKeyFigureModel'

export default class CollectionModel extends Model {
  constructor (data, included = null) {
    super(data, included)
  }

  get title () {
    return this.get('attributes.title')
  }

  get paragraphs () {
    const ps = this.get('rel.paragraph_content')

    if (!ps) return [] // au cas ou il n'y est aucun paragraph

    return ps.map((p) => { return new ParagraphModel(p, this._included) })
  }

  get collectionType () {
    return this.get('rel.collection_type.attributes.name')
  }

  get numOfDrawers () {
    return this.get('attributes.number_of_drawers')
  }

  get keyFigures () {
    const kf = this.get('rel.key_figures')
    if (!kf) return null
    return new ParagraphModel(this.get('rel.key_figures'), this._included)
  }

  get backgroundImg () {
    return this.get('rel.background.rel.field_image.attributes.url')
  }

  get derivatives () {
    return this.get('rel.background.rel.field_image.links')
  }
}
